
function getTranslations () {

}

export default getTranslations;